import { useTranslator } from '@Localization';
import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { IReviewProgress } from '../annotations.interface';
import { IAnnotationsStore } from '../annotations.store';
import { StatsProgress } from '../components/StatsProgress';

export const ReviewProgressContainer = observer((): ReactElement => {
  const annotationsStore = useInjection(IAnnotationsStore.$);

  const { t } = useTranslator();
  const { youAccepted, youRejected, allAccepted, allRejected, awaitingReview, totalImages }: IReviewProgress = annotationsStore.reviewProgress;

  const title = `${t('accepted_by_you')}: ${youAccepted} | ${t('rejected_by_you')}: ${youRejected} | ${t('all_accepted')}: ${allAccepted} | ${t('all_rejected')}: ${allRejected}`;

  return (
    <StatsProgress
      header={t('review_progress')}
      title={title}
      stats={[
        { label: t('reviewed_by_you'), value: (youAccepted + youRejected).toString() },
        { label: t('reviewed_by_all'), value: (allAccepted + allRejected).toString() },
        { label: t('awaiting_review'), value: awaitingReview.toString() },
        { label: t('images_in_total'), value: totalImages.toString() },
      ]}
    />
  );
});
